import Chart from 'chart.js/auto';
import { useEffect, useRef } from 'react';
import { EmailDailyStat } from 'services';
import { EMAIL_METRICS } from './constants';

interface Props {
  stats: EmailDailyStat[];
}

/** `_id` vem como `YYYY-MM-DD`; no eixo basta `DD/MM`. */
const toDayLabel = (id: string) => `${id.substring(8)}/${id.substring(5, 7)}`;

export default function EmailDailyChart({ stats }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const chart = new Chart(canvasRef.current, {
      type: 'line',
      data: {
        labels: stats.map(day => toDayLabel(day._id)),
        datasets: EMAIL_METRICS.filter(metric => metric.chart).map(metric => ({
          label: metric.label,
          borderColor: metric.color,
          backgroundColor: metric.color,
          fill: false,
          tension: 0.3,
          data: stats.map(day => day[metric.key] || 0),
        })),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
      },
    });

    return () => chart.destroy();
  }, [stats]);

  return (
    <div className="bg-white p-4 rounded shadow mb-4">
      <h4 className="text-lg font-bold mb-4">Evolução diária</h4>
      <div className="h-80">
        <canvas ref={canvasRef} />
      </div>
    </div>
  );
}
